import { colors } from '@mui/material';

export default {
	root: {
		backgroundColor: 'white'
	}
};
